import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";

export default function PlantillaStatusConfirmDialog({
  open,
  form,
  action = "archive",
  loading = false,
  onClose,
  onConfirm,
}) {
  const isArchive = action === "archive";
  const title = isArchive ? "¿Archivar plantilla?" : "¿Restaurar plantilla?";
  const description = isArchive
    ? `¿Estás seguro de que querés archivar la plantilla "${form?.name || ""}"? Dejará de estar disponible para nuevos envíos.`
    : `¿Estás seguro de que querés restaurar la plantilla "${form?.name || ""}"? Volverá a estar activa para su uso.`;
  const confirmText = isArchive
    ? loading
      ? "Archivando..."
      : "Archivar"
    : loading
    ? "Restaurando..."
    : "Restaurar";

  return (
    <Dialog
      open={open}
      onClose={!loading ? onClose : undefined}
      PaperProps={{
        sx: {
          borderRadius: "18px",
          maxWidth: 440,
          p: 1,
        },
      }}
    >
      <DialogTitle sx={{ fontSize: 18, fontWeight: 900, color: "primary.900" }}>
        {title}
      </DialogTitle>
      <DialogContent>
        <Typography sx={{ fontSize: 14, fontWeight: 600, color: "neutral.700" }}>
          {description}
        </Typography>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button
          onClick={onClose}
          disabled={loading}
          sx={{
            color: "primary.900",
            borderRadius: "24px",
            textTransform: "none",
            fontWeight: 800,
          }}
        >
          Cancelar
        </Button>
        <Button
          onClick={onConfirm}
          disabled={loading}
          startIcon={loading ? <CircularProgress size={16} color="inherit" /> : null}
          sx={{
            bgcolor: isArchive ? "error.main" : "primary.900",
            color: "white",
            px: 2.5,
            borderRadius: "24px",
            textTransform: "none",
            fontWeight: 800,
            "&:hover": {
              bgcolor: isArchive ? "error.dark" : "primary.800",
            },
          }}
        >
          {confirmText}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
